import styled from 'styled-components';
import AppCSS from '../../../../utils/styled';

export const Components = {
  Container: styled.div`
    width: 100%;
  `,

  Tab: styled.div`
    width: 100%;
    min-width: 300px;
    border-radius: 8px;
    border: 2px solid ${AppCSS.colors.black};
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  `,

  TabTitle: styled.div`
    ${AppCSS.fonts.h2};
    color: ${AppCSS.colors.black};
    text-align: center;
  `,

  Button: styled(AppCSS.buttonStyles.PrimaryButtonStyle)``,
  ButtonLabel: styled(AppCSS.buttonStyles.PrimaryButtonStyle)``,
};
